import { ShoppingCartIcon } from "@heroicons/react/24/outline"
import { usePanier } from "context/panier-context";
import uiConfig from "data/uiConfig";
import clsx from "clsx";

function ShoppingButton() {
  const { panier } = usePanier();
  const txtColor = uiConfig.navbar.color;
	const hoverColor = uiConfig.navbar.hover;

  return (
    <div className={clsx("relative mr-2", txtColor, hoverColor)}>
      {(panier?.produits?.length ?? 0) > 0 &&
        <span className="absolute bg-primary rounded-full text-sm h-[25px] w-[25px]
        flex justify-center items-center -right-2 -top-2
        ">{panier?.produits?.length}</span>
      }
      <a href="/panier" aria-label="Voir le panier">
        <ShoppingCartIcon className='w-8' />
      </a>
    </div>
  )
}

export default ShoppingButton